import { Box, InputAdornment, TextField } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { Dispatch, SetStateAction, useEffect, useState } from "react";
import ClearIcon from "@mui/icons-material/Clear";

type SearchProps = {
  value?: string;
  onChange?: any;
  onCross?: () => void;
  searchTerm: string;
  setDebouncedSearchTerm?: Dispatch<SetStateAction<string>>;
  placeholder: string
};

const SearchBar = ({
  value,
  onChange,
  onCross,
  setDebouncedSearchTerm,
  searchTerm,
  placeholder
}: SearchProps) => {
  const [localSearch, setLocalSearch] = useState(searchTerm || "");

  useEffect(() => {
    setLocalSearch(searchTerm || "");
  }, [searchTerm]);

  useEffect(() => {
    const delay = 1000;
    const timerId = setTimeout(() => {
      if (setDebouncedSearchTerm) {
        setDebouncedSearchTerm(localSearch);
      }
    }, delay);

    return () => {
      clearTimeout(timerId);
    };
  }, [localSearch]);

  return (
    <Box className="form search_bar">
      <TextField
        value={localSearch}
        onChange={(e) => {
          setLocalSearch(e.target.value.trimStart());
        }}
        onKeyDown={(e) => {
          if (e.key === "Enter" && setDebouncedSearchTerm) {
            setDebouncedSearchTerm(localSearch);
          }
        }}
        hiddenLabel
        placeholder={placeholder}
        className="txt_inpt"
        fullWidth
        InputProps={{
          startAdornment: (
            <InputAdornment position="start" className="search_icon">
              <img src="/static/images/searchbar_icon.svg" alt="Icon" />
            </InputAdornment>
          ),
          endAdornment: (
            <InputAdornment position="end" className="cross_btn">
              {localSearch ? (
                <ClearIcon
                  style={{ background: "white", color: "red", cursor: "pointer" }}
                  onClick={() => {
                    setLocalSearch("");
                    if (onCross) onCross();
                  }}
                />
              ) : null}
            </InputAdornment>
          ),
        }}
      />
    </Box>
  );
};

export default SearchBar;
